import { useLazyQuery } from "@apollo/client/react";
import { FormControl, Grid } from '@mui/material';
import React, { useEffect, useState, useMemo } from 'react';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { adaptTipoModuloArray } from '../../../adapters/tipoModuloAdapter';
import { SelectInput } from '../../../components/selectInput/SelectInput';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import './tabProgramas.scss';

import { GET_TIPO_MODULO } from '../../../data/graphQL/queries/TipoModulo/queries';

export default function TabProgramas({ idInsumo, listaProgramas, setListaProgramas }) {

  const [getProgramas, { data: programasData, loading: programasLoading }] = useLazyQuery(GET_TIPO_MODULO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!programasData) return;
    setProgramas(adaptTipoModuloArray(programasData));
  }, [programasData]);  

  const [programas, setProgramas] = useState([]);

  const handleRemove = (id) => {
    setListaProgramas([...listaProgramas.filter((x) => x.idTipoModulo != id)]);
  };

  const handleChange = (e) => {
    const item = {
      idInsumo: idInsumo,
      idTipoModulo: e.target.value
    };

    setListaProgramas((current) => [...current, item]);
  };

  useEffect(() => {
    if (!programasLoading) {
      getProgramas();
    }
  }, []);

  const initialColumns = [
  {
    field: 'name',
    headerName: 'Descripcion'
  },
  {
    headerName: '',
    field: 'action',
    flex: 0.02,
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return (
        <DeleteOutlineIcon
          className='edit-icon-no-margin'
          titleAccess='Eliminar'
          onClick={(e) => handleRemove(row.id)}
          sx={{ cursor: 'pointer' }} />);


    }
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), [listaProgramas]);

  return (
    <>
            <FormControl variant="outlined" sx={{ alignItems: 'left' }} fullWidth>
                <Grid
          container
          spacing={0}
          direction="row"
          alignItems="left"
          justifyContent="left">
 <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingBottom: '1%' }} size={{ xs: 12, md: 6, lg: 6 }}>
                        <SelectInput
              options={programas.filter((d) => !listaProgramas.some((savedPrograma) => savedPrograma.idTipoModulo === d.id))}
              label='Programas'
              placeHolder='Elige un Programa'
              onChange={handleChange} />
            
                    </Grid>
                </Grid>
                <Grid
          container
          spacing={1}
          direction="row"
          alignItems="left"
          justifyContent="left">
 <Grid sx={{ boxSizing: 'border-box', width: '100%', paddingTop: '2%' }} size={{ xs: 12, md: 12, lg: 12 }}>
                        <DataGridGenerico
              hideFooterPagination={false}
              columns={columns}
              rows={
              programas?.filter((allProgramas) => listaProgramas?.some((savedPrograma) => savedPrograma.idTipoModulo === allProgramas.id))
              }
              toolbar={false}
              totalCount={programas?.filter((allProgramas) => listaProgramas?.some((savedPrograma) => savedPrograma.idTipoModulo === allProgramas.id)).length} />
            
                    </Grid>
                </Grid>
            </FormControl>
        </>);

}